module.exports = __webpack_public_path__ + "static/g8-e4fe81c317c218455386c367faf7f71c.jpg";